module.exports = __webpack_public_path__ + "static/media/ba.d5ef14f0.svg";